import React, { useState, useEffect } from 'react';

export default function Download() {
  const [fileInfo, setFileInfo] = useState(null);
  const [downloadStarted, setDownloadStarted] = useState(false);
  const [platform, setPlatform] = useState('android');

  const API_DOWNLOAD_URL = '/api/downloads/apk';
  const IOS_PAGE_URL = '/mobile-web/ios.html';

  useEffect(() => {
    // Use backend API endpoint (returns correct Android Content-Type headers)
    fetch(API_DOWNLOAD_URL, { method: 'HEAD' })
      .then(r => {
        const size = r.headers.get('content-length');
        const lastMod = r.headers.get('last-modified');
        setFileInfo({
          size: size ? `${(parseInt(size) / 1024 / 1024).toFixed(1)} MB` : '~58 MB',
          lastModified: lastMod ? new Date(lastMod).toLocaleDateString('id-ID', {
            day: 'numeric', month: 'long', year: 'numeric'
          }) : new Date().toLocaleDateString('id-ID', {
            day: 'numeric', month: 'long', year: 'numeric'
          }),
        });
      })
      .catch(() => setFileInfo({
        size: '~58 MB',
        lastModified: new Date().toLocaleDateString('id-ID', {
          day: 'numeric', month: 'long', year: 'numeric'
        }),
      }));
  }, []);

  const handleDownload = () => {
    setDownloadStarted(true);
    setTimeout(() => setDownloadStarted(false), 5000);
  };

  const downloadUrl = API_DOWNLOAD_URL;

  // Tab switcher style
  const tabBase = {
    flex: 1,
    padding: '10px 16px',
    border: 'none',
    borderRadius: 30,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    transition: 'all 0.2s',
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '20px',
    }}>
      <div style={{
        maxWidth: 480,
        width: '100%',
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(20px)',
        borderRadius: 24,
        border: '1px solid rgba(255,255,255,0.1)',
        padding: '48px 36px',
        textAlign: 'center',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
      }}>
        {/* Logo */}
        <div style={{
          width: 80,
          height: 80,
          borderRadius: 20,
          background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          fontSize: 36,
          color: 'white',
          fontWeight: 700,
        }}>
          LS
        </div>

        <h1 style={{
          fontSize: 28,
          fontWeight: 700,
          color: '#f1f5f9',
          margin: '0 0 8px',
        }}>
          Layanan<span style={{ color: '#818cf8' }}>Synexa</span>
        </h1>

        <p style={{
          fontSize: 15,
          color: '#94a3b8',
          margin: '0 0 28px',
          lineHeight: 1.5,
        }}>
          Mobile App untuk teknisi & karyawan lapangan
        </p>

        {/* Platform switcher */}
        <div style={{
          display: 'flex',
          gap: 6,
          background: 'rgba(255,255,255,0.06)',
          borderRadius: 30,
          padding: 4,
          marginBottom: 28,
        }}>
          <button
            onClick={() => setPlatform('android')}
            style={{
              ...tabBase,
              background: platform === 'android'
                ? 'linear-gradient(135deg, #3b82f6, #6366f1)'
                : 'transparent',
              color: platform === 'android' ? '#fff' : '#94a3b8',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Android
          </button>
          <button
            onClick={() => setPlatform('ios')}
            style={{
              ...tabBase,
              background: platform === 'ios'
                ? 'linear-gradient(135deg, #6366f1, #8b5cf6)'
                : 'transparent',
              color: platform === 'ios' ? '#fff' : '#94a3b8',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
            iOS/iPhone
          </button>
        </div>

        {/* Android content */}
        {platform === 'android' && (
          <>
            {/* File info */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 24,
              marginBottom: 32,
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>Ukuran</div>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#e2e8f0' }}>
                  {fileInfo?.size || '...'}
                </div>
              </div>
              <div style={{
                width: 1,
                background: 'rgba(255,255,255,0.1)',
              }} />
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>Update</div>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#e2e8f0' }}>
                  {fileInfo?.lastModified || '...'}
                </div>
              </div>
            </div>

            {/* Download button */}
            <a
              href={downloadUrl}
              download="LayananSynexa.apk"
              onClick={handleDownload}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 10,
                padding: '16px 40px',
                background: downloadStarted
                  ? 'linear-gradient(135deg, #059669, #10b981)'
                  : 'linear-gradient(135deg, #3b82f6, #6366f1)',
                color: 'white',
                fontSize: 17,
                fontWeight: 600,
                borderRadius: 14,
                textDecoration: 'none',
                transition: 'all 0.2s',
                boxShadow: downloadStarted
                  ? '0 4px 14px rgba(5,150,105,0.4)'
                  : '0 4px 14px rgba(59,130,246,0.4)',
                marginBottom: 32,
              }}
              onMouseEnter={e => {
                if (!downloadStarted) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(59,130,246,0.5)';
                }
              }}
              onMouseLeave={e => {
                if (!downloadStarted) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 14px rgba(59,130,246,0.4)';
                }
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              {downloadStarted ? 'Download Dimulai... ✓' : 'Download APK'}
            </a>

            {/* Direct download link for mobile fallback */}
            <p style={{
              fontSize: 12,
              color: '#64748b',
              marginBottom: 24,
            }}>
              Jika download tidak berjalan otomatis,
              {' '}
              <a
                href={downloadUrl}
                style={{ color: '#818cf8' }}
              >
                klik di sini untuk download langsung
              </a>
            </p>

            {/* Install instructions */}
            <div style={{
              background: 'rgba(255,255,255,0.03)',
              borderRadius: 12,
              padding: '20px 24px',
              textAlign: 'left',
              border: '1px solid rgba(255,255,255,0.05)',
            }}>
              <h3 style={{
                fontSize: 14,
                fontWeight: 600,
                color: '#cbd5e1',
                margin: '0 0 12px',
                textAlign: 'center',
              }}>
                📱 Cara Install di Android
              </h3>
              <ol style={{
                fontSize: 13,
                color: '#94a3b8',
                margin: 0,
                paddingLeft: 18,
                lineHeight: 1.8,
              }}>
                <li>Klik tombol <strong style={{ color: '#e2e8f0' }}>Download APK</strong> di atas</li>
                <li>Setelah download selesai, buka file <strong style={{ color: '#e2e8f0' }}>LayananSynexa.apk</strong></li>
                <li>Jika muncul peringatan "Pasang aplikasi dari sumber tidak dikenal", pilih <strong style={{ color: '#e2e8f0' }}>Setelan</strong> lalu aktifkan <strong style={{ color: '#e2e8f0' }}>Izinkan dari sumber ini</strong></li>
                <li>Kembali dan tekan <strong style={{ color: '#e2e8f0' }}>Pasang</strong></li>
                <li>Tunggu proses instalasi selesai, lalu buka aplikasi</li>
              </ol>
            </div>
          </>
        )}

        {/* iOS content */}
        {platform === 'ios' && (
          <>
            <div style={{
              background: 'rgba(250,204,21,0.08)',
              border: '1px solid rgba(250,204,21,0.25)',
              borderRadius: 12,
              padding: '14px 16px',
              fontSize: 13,
              color: '#fbbf24',
              marginBottom: 24,
              lineHeight: 1.5,
            }}>
              ⚠️ Aplikasi iOS sedang disiapkan. iPhone tidak mengizinkan install
              langsung dari website — aplikasi akan dibagikan melalui TestFlight
              (undangan email) atau App Store.
            </div>

            <div style={{
              background: 'rgba(255,255,255,0.03)',
              borderRadius: 12,
              padding: '20px 24px',
              textAlign: 'left',
              border: '1px solid rgba(255,255,255,0.05)',
              marginBottom: 24,
            }}>
              <h3 style={{
                fontSize: 14,
                fontWeight: 600,
                color: '#cbd5e1',
                margin: '0 0 12px',
                textAlign: 'center',
              }}>
                🍎 Cara Install di iPhone (TestFlight)
              </h3>
              <ol style={{
                fontSize: 13,
                color: '#94a3b8',
                margin: 0,
                paddingLeft: 18,
                lineHeight: 1.8,
              }}>
                <li>Admin mengirim <strong style={{ color: '#e2e8f0' }}>undangan TestFlight</strong> ke email teknisi</li>
                <li>Buka email di iPhone → ketuk <strong style={{ color: '#e2e8f0' }}>View in TestFlight</strong></li>
                <li>Install aplikasi <strong style={{ color: '#e2e8f0' }}>TestFlight</strong> dari App Store jika belum ada</li>
                <li>Install <strong style={{ color: '#e2e8f0' }}>LayananSynexa</strong> dari TestFlight</li>
              </ol>
            </div>

            {/* iOS info button */}
            <a
              href={IOS_PAGE_URL}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 10,
                padding: '16px 40px',
                background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                color: 'white',
                fontSize: 17,
                fontWeight: 600,
                borderRadius: 14,
                textDecoration: 'none',
                transition: 'all 0.2s',
                boxShadow: '0 4px 14px rgba(99,102,241,0.4)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(99,102,241,0.5)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 14px rgba(99,102,241,0.4)';
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              Halaman Info iOS
            </a>

            <p style={{
              fontSize: 12,
              color: '#64748b',
              margin: '20px 0 0',
              lineHeight: 1.6,
            }}>
              Setelah build iOS tersedia, tombol di halaman ini akan menampilkan
              link TestFlight langsung untuk teknisi.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
